import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import translate from '../../../../translate';
import PhysicalCard from '../../../Landing2.0/assets/images/pyshical-card.svg';
import NotFee from '../../../Landing2.0/assets/images/not-fee.svg';
import CoinsImg from '../../../Landing2.0/assets/images/finanzas-tradicionales.svg';
import './payCrypto.css';

const PayCripto = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.section2;
  return(
    <div className='background-orange'>
      <div>
        <Container>
          <Row className='orange-section-margin-row'>
            <Col xl={12} className='orange-section-align'>
              <h1 className='orange-section-title'>{transl.title}</h1>
            </Col>
          </Row>
        </Container>
        <Container fluid className='wrapper-cards-orange'>
          <Row>
            <Col xl={4} md={4}>
              <div className='wrapper-orange-section-pay-crypto'>
                <div className='wrapper-orange-section-pay-crypto-img'>
                  <Image src={PhysicalCard} className='physical-img'/>
                </div>
                <div>
                  <h1 className='title-wrapper-orange-section'>{transl.card1_title}</h1>
                </div>
                <div>
                  <p className='text-wrapper-orange-section'>{transl.card1_subtitle}</p>
                </div>
              </div>
            </Col>
            <Col xl={4} md={4}>
              <div className='wrapper-orange-section-pay-crypto'>
                <div className='wrapper-orange-section-pay-crypto-img'>
                  <Image src={NotFee} className='no-fee-img'/>
                </div>
                <div>
                  <h1 className='title-wrapper-orange-section'>{transl.card2_title}</h1>
                </div>
                <div>
                  <p className='text-wrapper-orange-section'>
                    {transl.card2_subtitle}
                  </p>
                </div>
              </div>
            </Col>
            <Col xl={4} md={4}>
              <div className='wrapper-orange-section-pay-crypto'>
                <div className='wrapper-orange-section-pay-crypto-img'>
                  <Image src={CoinsImg} className='coin-img'/>
                </div>
                <div>
                  <h1 className='title-wrapper-orange-section'>{transl.card3_title}</h1>
                </div>
                <div>
                  <p className='text-wrapper-orange-section'>
                  {transl.card3_subtitle}
                  </p>
                </div>
              </div>
            </Col>
          </Row> 
        </Container>
      </div>
    </div>
  )

}

export default PayCripto;